import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view";
import {QUICK_FILTER_ALL_VALUES} from "../../../../gd/const/quick-filter";
import TaskTypeIcon from "../../../../gd-components/icons/task-icon/task-icon-ui5";


export default function FieldStoryPoint_QuickFilterView(props: FieldQuickFilterViewProps) {


    const {value} = props



    let icon    = null
    let label   = 'Unknown'

    switch (value) {
        case QUICK_FILTER_ALL_VALUES :
            label = 'All story points'
            return (
                <div className="ui5-group-by-view">
                    <div className="name">{label}</div>
                </div>
            )

        case null:
        case 'null':
            return (
                <div className="ui5-group-by-view">
                    <div className="name">Not set</div>
                </div>
            )

        default:
            const options = gd.session.companies.get(gd.companyId).settings.fields.storyPoints;

            let valueLabel = '';
            if (!_.isNil(value)) {
                const found = _.find(options, option=>option.value === value);
                valueLabel = found ? found.label : value;
            }

            const classes = Classes("ui5-story-points", "s-24", {
                'not-set': _.isNil(value)
            })


            return (
                <div className="ui5-group-by-view">
                    {/*<div className="name">{label}</div>*/}
                    <div className={classes}>{valueLabel}</div>
                </div>
            )
    }







}